import { useMutation } from "@tanstack/react-query";
import { updatePassword } from ".";
import { queryKeys } from "@/lib/useQuery/queryKeys";

export function useUpdatePassword(){
    return useMutation({
        mutationKey: queryKeys.user._def,
        mutationFn: updatePassword,
    })
}